<template>
  <div>
    <div class="body">
      <van-image
        class="topLogo"
        :src="require('../../../../public/image/03/1.png')"
      ></van-image>
      <div class="bodywarp">
        <div :class="{ roleImage: true }">
          <van-swipe class="my-swipe" @change="onChange" ref="swiper">
            <van-swipe-item v-for="item in swiperList" :key="item.image">
              <img @dragstart.prevent class="swiperImage1" :src="item.image" />
            </van-swipe-item>
            <template #indicator> <div></div> </template>
          </van-swipe>
          <div
            :class="{ mobile: isMobile, pc: !isMobile, roleListImage: true }"
          >
            <a
              href="javascript:;"
              v-for="(item, index) in zyList"
              :key="index"
              @click="changeImage(index)"
            >
              <van-image
                v-show="zyListIndex === index"
                :src="item.image"
              ></van-image>
              <van-image
                v-show="zyListIndex !== index"
                :src="item.dimage"
              ></van-image>
            </a>
            <!-- <a href="javascript:;" @click="changeImage(1)"></a>
            <a href="javascript:;" @click="changeImage(2)"></a>
            <a href="javascript:;" @click="changeImage(3)"></a>
            <a href="javascript:;" @click="changeImage(4)"></a> -->
          </div>
          <div class="roleImageText" :class="{ roleImageText: true }">
            <van-image
              :src="require('../../../../public/image/03/4.png')"
            ></van-image>
          </div>
          <div class="roleImagebutton">
            <van-image
              @click="clickme"
              :src="require('../../../../public/image/03/5.png')"
            ></van-image>
          </div>
        </div>
      </div>
    </div>
    <SLMDialog
      :backgroundImage="require('../../../../public/image/12/8/1.png')"
      :removeImage="require('../../../../public/image/12/8/3.png')"
      :textImage="require('../../../../public/image/12/2/1.png')"
      :textImage1="require('../../../../public/image/12/2/3.png')"
      :titleImage="require('../../../../public/image/12/2/2.png')"
      :iconImage="require('../../../../public/image/12/2/4.png')"
      :visible.sync="showSLMD"
      @scrollIntoView="scrollIntoView"
      @changeVisible="showSLMD = !showSLMD"
    />
  </div>
</template>

<script>
import isMobile from '../../../../utils/isMobile.js'
import getData from '../../../../utils/request/request'
import SLMDialog from '../components/SLMDialog/index.vue'
import browser from '../../../../utils/browser.js'
import getButton from '../../../../utils/getButton'

import { Toast } from 'vant'
import { mapGetters } from 'vuex'

export default {
  components: {
    SLMDialog
  },
  computed: {
    ...mapGetters(['phone', 'gameStatus'])
  },
  data() {
    return {
      browser: browser(),
      showSLMD: false,
      checked: false,
      isMobile: isMobile(),
      zyListIndex: 0,
      // showImage: '01.png',
      zyList: [
        {
          dimage: require('../../../../public/image/03/4/1/1.png'),
          image: require('../../../../public/image/03/4/2/1.png')
        },
        {
          dimage: require('../../../../public/image/03/4/1/2.png'),
          image: require('../../../../public/image/03/4/2/2.png')
        },
        {
          dimage: require('../../../../public/image/03/4/1/3.png'),
          image: require('../../../../public/image/03/4/2/3.png')
        },
        {
          dimage: require('../../../../public/image/03/4/1/4.png'),
          image: require('../../../../public/image/03/4/2/4.png')
        },
        {
          dimage: require('../../../../public/image/03/4/1/5.png'),
          image: require('../../../../public/image/03/4/2/5.png')
        }
      ],
      swiperList: [
        {
          image: require('../../../../public/image/03/3/01.png'),
          name: '劍士',
          title: '職業圖標-劍士'
        },
        {
          image: require('../../../../public/image/03/3/02.png'),
          name: '魔術師',
          title: '職業圖標-魔術師'
        },
        {
          image: require('../../../../public/image/03/3/03.png'),
          name: '弓箭手',
          title: '職業圖標-弓箭手'
        },
        {
          image: require('../../../../public/image/03/3/04.png'),
          name: '格鬥士',
          title: '職業圖標-格鬥士'
        },
        {
          image: require('../../../../public/image/03/3/05.png'),
          name: '傳教士',
          title: '職業圖標-傳教士'
        }
      ]
    }
  },
  methods: {
    scrollIntoView(val) {
      this.$emit('scrollIntoView', val)
    },
    async send_gift() {
      let Api = {
        url: '/api/send_gift',
        type: 'post'
      }
      let form = {
        type: 'zy',
        zy: this.swiperList[this.zyListIndex].name,
        phone: this.phone
      }
      let res = await getData(this.$http(Api, form))
      if (res.code === 1) {
        this.$emit('getStatus')
        const url = encodeURIComponent(
          'https://www.lingluk.com/crossgate.tw/prereg'
        )
        const facebook = `https://www.facebook.com/sharer/sharer.php?u=${url}`
        if (this.browser.iPhone) {
          window.location.href = facebook
        } else if (this.browser.android) {
          window.open(facebook)
        } else {
          window.open(facebook)
        }
        let _this = this
        setTimeout(() => {
          _this.showSLMD = true
        }, 1000)
      } else {
        switch (res.msg) {
          case '請先完成手機預約':
            this.$emit('showPhoneHandel')
            break
          case '禮包碼已領完':
            Toast(res.msg)
            break
          default:
            Toast(res.msg)
            break
        }
      }
    },
    async clickme() {
      getButton('職業選擇頁-選擇並分享職業')
      await this.send_gift()
      // const _this = this
      // setTimeout(() => {
      //   FB.ui(
      //     {
      //       display: 'popup',
      //       method: 'share_open_graph',
      //       action_type: 'og.likes',
      //       action_properties: JSON.stringify({
      //         object: 'https://www.lingluk.com/crossgate.tw/prereg'
      //       })
      //     },
      //     function (response) {
      //       if (!response || response.error_message) {
      //         Toast('分享失败')
      //       } else {
      //         _this.send_gift()
      //       }
      //     }
      //   )
      // }, 0)
    },
    onChange(index) {
      this.zyListIndex = index
      getButton(this.swiperList[index].title)
      // this.$refs.swiper.swipeTo(index)
    },
    changeImage(index) {
      this.$refs.swiper.swipeTo(index)
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes heartbeat {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.body {
  &::before {
    content: '';
    display: table;
  }
  position: relative;
  width: 100%;
  background: url(../../../../public/image/10/03.jpg) no-repeat;
  background-size: 100% 100%;
  .topLogo {
    width: 80%;
    box-sizing: border-box;
    display: block;
    margin: 0 auto;
    margin-top: 50px;
  }
  .bodywarp {
    background-size: 100% 100%;
    width: 95%;
    margin: 0 auto;
    box-sizing: border-box;
    .roleImage {
      display: flex;
      align-content: center;
      flex-wrap: wrap;
      height: 100%;
      .my-swipe {
        width: 90%;
        margin: auto;
      }
      .swiperImage1 {
        display: block;
        width: 100%;
        margin: auto;
        box-sizing: border-box;
      }
      .pc {
        height: calc((8 / 15 * 100vh) * 108 / 511 * 0.7);
      }
      .mobile {
        height: calc(100vw * 108 / 511 * 0.7);
      }
      .roleImageText {
        margin: 0 auto;
        width: 80%;
        padding: 0.2rem 0;
        margin-top: 10px;
        margin-bottom: 10px;
      }
      .roleListImage {
        width: 70%;
        // background: url(../../../../public/image/03/3.png) no-repeat;
        // background-size: 100% 100%;
        display: flex;
        justify-content: space-between;
        margin: 0 auto;
        box-sizing: border-box;
        a {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .roleImagebutton {
        /deep/ .van-image {
          animation: heartbeat 1s ease infinite;
        }
        margin: 0 auto;
        width: 65%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/route/src/prereg/Activity03/index.vue